import { j as m } from "../../../../jsx-runtime-B6kdoens.js";
import { a as t } from "../../../../index-CROKJrb5.js";
import { c as s, f as e } from "../../../../create-component-CBAeEoQ6.js";
import { CardImage as c } from "../../CardImage/index.js";
const n = s(
  "ProductCardImage",
  e(
    ({ className: r, ...o }, a) => /* @__PURE__ */ m.jsx(
      c,
      {
        ref: a,
        className: t("cur-shrink", r),
        ...o
      }
    )
  )
);
export {
  n as ProductCardImage
};
//# sourceMappingURL=index.js.map
